module.exports = "/_next/static/images/1-b346b7c777b521ccd4a76dadf699f547.gif";